import axios from 'axios';
import Cookies from 'js-cookie';

import { apiBaseURL } from './config';

export const jwt = (() => {
  if (process.env.NODE_ENV === 'development') {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('jwt')) {
      return urlParams.get('jwt');
    } else if (Cookies.get('_jwt')) {
      return Cookies.get('_jwt');
    } else {
      return process.env.REACT_APP_PLATFORM_JWT;
    }
  } else {
    return Cookies.get('_jwt');
  }
})();

const authFetch = axios.create({
  baseURL: apiBaseURL,
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${jwt}`,
  },
});

export const proxiedFetch = (url: string, extra?: Parameters<typeof authFetch>[1]) => authFetch(`${apiBaseURL}/api/interactive_maps/proxy?url=${encodeURIComponent(url)}`, extra);

export default authFetch;
